export const PRODUCT_TYPES = {
  ARTICLE: 1,
  SERVICE: 2,
}

export const PRODUCT_TYPE_NAME = {
  [PRODUCT_TYPES.ARTICLE]: 'Artículo',
  [PRODUCT_TYPES.SERVICE]: 'Servicio'
}

export const PRODUCT_TYPE_OPTIONS = [
  {
    value: PRODUCT_TYPES.ARTICLE,
    label: PRODUCT_TYPE_NAME[PRODUCT_TYPES.ARTICLE]
  },
  {
    value: PRODUCT_TYPES.SERVICE,
    label: PRODUCT_TYPE_NAME[PRODUCT_TYPES.SERVICE]
  }
]
